import React from 'react';
import { CardBody } from "reactstrap";
import {getErrorText} from '../../lib/Utils';
import {toast} from 'react-toastify';


import 'spinkit/css/spinkit.css';

export default class WaitableCard extends React.Component {


  render() {
    let { entity, children, style, resetOnError} = this.props;
    let isLoading = false;
    let error = false;
    let errorText = false;

    if (entity) {
      isLoading = entity.get("isFetching");
      //isLoading = entity.isFetching;
      let object = entity.toObject();
      //let object = entity;
      error = object.error;
      if (error && object) {
        errorText = getErrorText(this.props.errorText, object.error);
       
      }
    }
    
    if(error && errorText){
      toast.error(errorText.message);
      if(resetOnError){
        resetOnError();
      }
    }
    

    return (<div className="animated">     
      {isLoading ?
        <CardBody style={style}>
            <div className="sk-wave">
            <div className="sk-rect sk-rect1"></div>&nbsp;
            <div className="sk-rect sk-rect2"></div>&nbsp;
            <div className="sk-rect sk-rect3"></div>&nbsp;
            <div className="sk-rect sk-rect4"></div>&nbsp;
            <div className="sk-rect sk-rect5"></div>
          </div>
        </CardBody> :
        <CardBody style={style}>
          {children}
        </CardBody>
      }
    </div>);
  }

}


// WEBPACK FOOTER //
// ./src/components/WaitableCard/WaitableCard.js